<template>
  <div :class="['score-table', `score-table--${theme}`]">
    <p class="score-table__title">
      {{ $translate('highestScore') }}
    </p>
    <div class="score-table__table">
      <ul class="table__column">
        <li class="table__item">{{ $translate('ranking') }}</li>
        <li
          v-for="(r) in range"
          :key="r.userId"
          class="table__item"
          :class="{ 'table__item--disable': r.userId !== $store.state.userData.userId }"
          v-html="r.rank"
        ></li>
      </ul>

      <span class="table__column-separator" />

      <ul class="table__column">
        <li class="table__item">{{ $translate('score') }}</li>
        <li
          v-for="(r) in range"
          :key="r.userId"
          class="table__item"
          :class="{ 'table__item--disable': r.userId !== $store.state.userData.userId }"
          v-html="r.score"
        ></li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ScoreTable',

  props: {
    theme: {
      type: String,
      required: false,
      default: 'red',
    },
  },

  computed: {
    range() {
      let prev = null;
      let next = null;
      let current = null;

      const currentIndex = this.$store.state.userData.scoreRange.findIndex((c) => { // eslint-disable-line
        return c.userId === this.$store.state.userData.userId;
      });

      current = this.$store.state.userData.scoreRange[currentIndex];
      prev = this.$store.state.userData.scoreRange[currentIndex - 1] || null;
      next = this.$store.state.userData.scoreRange[currentIndex + 1] || null;

      return [prev, current, next].filter((i) => i);
    },
  },
};
</script>

<style lang="scss" scoped>
.score-table {
  text-align: center;

  &.score-table--red {
    color: $red;

    .table__column-separator {
      background-color: $red;
    }
  }

  &.score-table--white {
    color: $white;

    .table__column-separator {
      background-color: $white;
    }
  }

  &__title {
    margin-bottom: 10px;
  }

  &__table {
    position: relative;
    width: 100%;

    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .table__column {
    flex: 0 0 40%;
    width: 40%;

    @extend %font-small;
  }

  .table__item--active {
    font-size: 22px;
    line-height: 28px;
  }

  .table__item--disable {
    opacity: 0.6;
  }

  .table__column-separator {
    display: block;
    position: absolute;
    top: 0;
    left: 50%;
    width: 1px;
    height: 100%;
  }
}
</style>
